// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1shHU","loaderOuter":"PageOverlayLoader_loaderOuter__C3iew"};